




import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
export default class FileTypeValidator extends Vue {
    @Prop() readonly fileName!: string;
    @Prop() readonly acceptFileTypes!: string;

    public isFileTypeValid (): boolean {
      if (!this.fileName) return true;
      const fileExtension = this.fileName.split('.').pop()?.toLowerCase();
      return !this.acceptFileTypes || this.acceptFileTypes.toLowerCase().includes(fileExtension || '');
    }

    public getMessage (): string {
      if (this.isFileTypeValid()) {
        return '';
      }
      const fileExtension = this.fileName.split('.').pop()?.toLowerCase();
      return `.${fileExtension} is not a valid file type. Allowed types: ${this.acceptFileTypes}`;
    }

    public getValidationClass (): string {
      return this.isFileTypeValid() ? 'field-validation-valid' : 'field-validation-error';
    }
}
